<template>
    <div>
        <Head :title="__('Two Factor Verification')"/>

        <form
            @submit.prevent="attempt"
            class="bg-white dark:bg-gray-800 shadow rounded-lg p-8 max-w-[25rem] mx-auto"
        >
            <Heading class="text-center">
                Two Factor Verification
            </Heading>

            <p class="text-muted text-center mb-11">
                You have received an email which contains two factor login code.
                If you haven't received it, press
                <Link
                    :href="verifyResendPath"
                    class="text-gray-500 font-bold no-underline"
                    v-text="__('here')"
                />.
            </p>

            <div class="mb-6">
                <input
                    v-model="form.two_factor_code"
                    class="form-control form-input form-input-bordered w-full"
                    :class="{ 'form-input-border-error': form.errors.has('two_factor_code') }"
                    id="two_factor_code"
                    type="text"
                    name="two_factor_code"
                    autofocus=""
                    required
                />
                <HelpText class="mt-2 text-red-500" v-if="form.errors.has('two_factor_code')">
                    {{ form.errors.first('two_factor_code') }}
                </HelpText>
            </div>

            <DefaultButton class="w-full flex justify-center mb-6" type="submit">
                <span>
                    {{ __('Verify') }}
                </span>
            </DefaultButton>
        </form>
    </div>
</template>

<script>
import Auth from '@/layouts/Auth'

export default {
    name: "TwoFactorAuthPage",

    layout: Auth,

    data: () => ({
        form: Nova.form({
            two_factor_code: ''
        }),
    }),

    props: {
    },

    methods: {
        async attempt() {
            const {redirect} = await this.form.post(Nova.url('/verify'))

            if (redirect !== undefined && redirect !== null) {
                window.location.href = redirect
            }

            window.location.href = Nova.config('base')
            //Nova.visit('/') // Missing dashboard auth
        },
    },

    //TODO PATH /verify/resend
    computed: {
        verifyResendPath() {
            return Nova.config('/verify/resend')
        },
    },
}
</script>